
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SearchFilters } from "./SearchFilters";
import { SearchResults } from "./SearchResults";
import { Search, Settings } from "lucide-react";

interface AdvancedSearchDialogProps {
  children: React.ReactNode;
}

export const AdvancedSearchDialog = ({ children }: AdvancedSearchDialogProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState({});
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Search className="h-5 w-5" />
            Advanced Search
          </DialogTitle>
        </DialogHeader>
        
        <div className="flex-1 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 h-full">
            {/* Search Input and Filters */}
            <div className="lg:col-span-1 space-y-4">
              <div className="space-y-2">
                <label className="text-sm font-medium">Search Query</label>
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-black" />
                  <Input
                    placeholder="Search knowledge..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="pl-10"
                  />
                </div>
              </div>
              
              <SearchFilters 
                filters={filters} 
                onFiltersChange={setFilters} 
              />
            </div>

            {/* Search Results */}
            <div className="lg:col-span-3 overflow-y-auto">
              <SearchResults 
                searchQuery={searchQuery} 
                filters={filters} 
              />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
